import React from "react";

export default function PercentageModal({
  title,
  description,
  value,
  onChange,
}) {
  const circles = Array.from({ length: 11 }, (_, i) => i);

  const percentage = value * 10;

  return (
    <div className="w-full bg-white shadow-lg rounded-[12px] p-6">
      {/* Header */}
      <div className="flex justify-between items-start space-y-2">
        <div>
          <p className="text-[18px] font-bold text-black">{title}</p>

          <p className="text-[14px] text-[#808080] mt-2">{description}</p>
        </div>

        <div className="px-4 py-2 rounded-lg text-sm font-semibold flex items-center bg-blue-100">
          <span className="text-primary text-[18px]">{percentage}%</span>
        </div>
      </div>

      {/* Selector */}
      <div className="flex items-center justify-between mt-8">
        {circles.map((circle, index) => (
          <React.Fragment key={circle}>
            <button
              onClick={() => onChange(circle)}
              className={`size-6 rounded-full transition-all duration-200
              ${
                circle <= value
                  ? "bg-primary ring-4 ring-blue-100"
                  : "bg-[#BDBDBD] hover:bg-gray-400"
              }`}
            />

            {index !== circles.length - 1 && (
              <div className="w-2 h-1 rounded-full bg-[#BDBDBD]" />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center mt-8">
        <span className="text-[#808080] text-[18px]">0%</span>

        <span className="text-primary font-bold text-[18px]">
          Selected: {percentage}%
        </span>

        <span className="text-[#808080] text-[18px]">100%</span>
      </div>
    </div>
  );
}
